import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { firstValueFrom, lastValueFrom, tap } from 'rxjs';
import { StartupService } from './startup.service';
declare var window: any;

@Injectable({
  providedIn: 'root'
})
export class InitEnviromentService {
  private readonly http = inject(HttpClient)
  enviromentDetais = signal(null);

  public init(): Promise<any> {
    return firstValueFrom(

      this.http.get('assets/app-config.json').pipe(tap(config => {
        window.config = config;
        this.enviromentDetais.set(config)
      }))
    )
  }
}
